import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosClient from "../../../services/api/axiosInstance";
import type { PromptTemplateData } from "../models/Prompt";

export const PROMPTS_QUERY_KEY = "prompts";

export const usePrompts = () =>
  useQuery<PromptTemplateData[]>({
    queryKey: [PROMPTS_QUERY_KEY],
    queryFn: async ({ signal }) => {
      const response = await axiosClient.get<PromptTemplateData[]>(
        "/api/v1/ai-settings/prompt-templates/",
        {
          signal,
        }
      );

      return response?.data;
    },
    placeholderData: keepPreviousData,
    staleTime: 60000,
  });
